import { v4 as uuidv4 } from 'uuid';

import dateService from '@gem/services/date-service';

import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { Payload } from 'STORE/Messages/Message/Payload/Payload';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

interface IGetMessageData {
  groupId: string;
  payload: Payload;
  scheduleTime: number;
  clientUuid?: string;
  clientTime?: number;
  repliedMessage?: ChatMessage;
  quote?: Quote;
}

interface IMessageData {
  id: string;
  clientUuid: string;
  clientTime: number;
  serverTime: number;
  delay: number;
  groupId: string;
  senderId: string;
  repliedMessageId?: string;
  repliedMessage?: ChatMessage;
  quote?: Quote;
  payload: Record<string, any>;
}

export function getScheduledMessageData(data: IGetMessageData): IMessageData {
  const {
    groupId,
    payload,
    scheduleTime,
    clientTime = dateService.now().getTime(),
    clientUuid = uuidv4(),
    repliedMessage,
    quote,
  } = data;

  return {
    id: clientUuid,
    clientUuid,
    clientTime,
    serverTime: clientTime,
    delay: scheduleTime - dateService.now().getTime(),
    groupId,
    senderId: Entities.usersStore.Me.id,
    repliedMessageId: repliedMessage && repliedMessage.id,
    repliedMessage: repliedMessage,
    quote: quote,
    payload: payload.toJSON(),
  };
}
